import { render, staticRenderFns } from "./SelectField.vue?vue&type=template&id=45a81453&"
import script from "./SelectField.vue?vue&type=script&lang=ts&"
export * from "./SelectField.vue?vue&type=script&lang=ts&"
import style0 from "./SelectField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports